module.exports = __webpack_public_path__ + "img/tooltip_02-vallone-aure.6a9f060f.jpg";